import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import VerificationModal from "./VerificationModal";
import {
  setSinglePaymentObj,
  setWalletObj,
} from "../../../../features/obj/objSlice";
import {
  fetchData,
  fetchFundsTransfer,
  fetchPaybills,
  fetchPaymentModes,
  fetchSubwalletDropdown,
} from "../../../../features/fetch/fetchSlice";
import PhoneInput from "react-phone-input-2";
import { formatText } from "../../../../utils";
import { save } from "../../../../features/save/saveSlice";
import AddPaybillModal from "../../../setup/paybill/modal/AddPaybillModal";
import CategoryAdd from "../../../setup/category/modal/CategoryAdd";
import SubCategoryAdd from "../../../setup/sub-category/modal/SubCategoryAdd";
import TransferModal from "../../../funds-transfer/modal/TransferModal";
import { useWatch } from "antd/es/form/Form";
import { identifierTypeData } from "../../../../data";

const { TextArea } = Input;

const MpesaPaymentModal = ({
  open,
  handleCancel,
  handleFetchData,
  setopenSingle,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const urlCat = "api/v1/payments/fetch-payment-categories";
  const urlSubCat = "api/v1/payments/fetch-sub-categories";
  const urlPaybill = "api/v1/payments/fetch-paybills";

  const { loading, dataCat, dataSubCat } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataCat: state.fetch.data[urlCat] || [],
    dataSubCat: state.fetch.data[urlSubCat] || [],
  }));

  const { subwalletData, paybills, dropLoading, paymentModes } = useSelector(
    (state) => state.fetch,
  );

  const { saving } = useSelector((state) => state.save);
  const { user } = useSelector((state) => state.auth);
  const { singlePaymentObj } = useSelector((state) => state.obj);
  const [paymentSourceName, setPaymentSourceName] = useState();
  const [paybillName, setPaybillName] = useState();
  const [paymentModeName, setPaymentModeName] = useState();

  const [categoryName, setCategoryName] = useState();
  const [subCategoryName, setSubCategoryName] = useState();
  const [isAccountValidated, setIsAccountValidated] = useState(false);

  const payReceiverMobileNo = useWatch("payReceiverMobileNo", form);
  const isValidPhoneNumber = payReceiverMobileNo?.length === 12;
  const prevPhoneNumberRef = useRef(null);
  const payValidate = useWatch("payValidate", form);
  const payIdentifierType = useWatch("payIdentifierType", form);

  const getIdentifierLabel = () => {
    const selected = identifierTypeData?.find(
      (item) => item.value === payIdentifierType,
    );
    return selected?.label || "ID Number";
  };

  const [openPaybill, setopenPaybill] = useState(false);
  function handleCancelPaybill() {
    setopenPaybill(false);
  }

  const [openCategory, setopenCategory] = useState(false);
  function handleCancelCategory() {
    setopenCategory(false);
  }

  const [openSubCategory, setopenSubCategory] = useState(false);
  function handleCancelSubCategory() {
    setopenSubCategory(false);
  }

  const [openVerification, setopenVerification] = useState(false);
  async function handleCancelVerification() {
    await setopenVerification(false);
    await setopenSingle(true);
  }
  async function handleOpenVerification() {
    await setopenVerification(true);
    await setopenSingle(false);
    await handleCancel();
  }

  async function handleCancelSingle() {
    await handleCancel();
    await form.resetFields();
    await setSubCategoryName();
    await setCategoryName();
    await setShow();
    await setEnteredAmount(null);
    await setSelectedWallet(null);
  }
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [enteredAmount, setEnteredAmount] = useState(null);
  const [formData, setFormData] = useState();
  const [show, setShow] = useState(singlePaymentObj?.paymentMethod);

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const [openTransfer, setOpenTransfer] = useState(false);
  const handleOpenTransfer = async () => {
    await setOpenTransfer(true);
    await handleCancel();
  };
  const handleCancelTransfer = async () => {
    await setOpenTransfer(false);
    await setopenSingle(true);
  };

  const onFinish = async (data) => {
    data.pyType = "MOBILE_MONEY";
    data.paymentSourceName = paymentSourceName;
    data.categoryName = categoryName;
    data.subCategoryName = subCategoryName;
    data.paybillName = paybillName;
    data.paymentModeName = paymentModeName;
    if (!data.payValidate) {
      delete data.payValidate;
    }
    delete data.payBeneficiaryDetails;
    await dispatch(setSinglePaymentObj(data));
    await handleOpenVerification();
  };

  async function handleValidValidate() {
    if (!payReceiverMobileNo) {
      toast.error("Please select payment number first");
      return;
    }
    const res = await dispatch(
      save({
        url: "api/v1/payments/fetch-search-directory",
        dirNumber: payReceiverMobileNo,
      }),
    ); 
    if (res?.payload?.success) {
      form.setFieldsValue({
        payBeneficiaryDetails: res?.payload?.data?.result?.[0]?.dirName,
      });
      setIsAccountValidated(true);
    } else {
      await form.setFieldsValue({
        payBeneficiaryDetails: null,
      });
      await setIsAccountValidated(false); 
    }
  }

  const handleViewWallet = async (item) => {
    await dispatch(setWalletObj(item));
    await navigate("/my-wallet-view");
  };

  const handleTransfer = async (item) => {
    await handleOpenTransfer();
  };
  async function fetchSubWalletData() {
    dispatch(
      fetchSubwalletDropdown({
        url: `api/v1/wallet/sub/${user?.disbursementWalId}`,
      }),
    );
  }

  async function fetchSubCategoryData(value) {
    dispatch(
      fetchData({
        url: urlSubCat,
        pcId: value,
      }),
    );
  }

  async function fetchPaybillData(value) {
    dispatch(
      fetchPaybills({
        url: urlPaybill,
        pbType: value ?? "TILL NUMBER",
      }),
    );
  }

  async function fetchCategoryData() {
    dispatch(
      fetchData({
        url: urlCat,
        start: 0,
        limit: null,
      }),
    );
  }

  async function fetchFundsTransferData() {
    dispatch(
      fetchFundsTransfer({
        url: "api/v1/wallet/fetch-fund-transfers",
        limit: null,
        start: 0,
        transaStatus: null,
        transaSourceWallet: null,
      }),
    );
  }
  async function fetchPaymentModesData() {
    await dispatch(
      fetchPaymentModes({
        url: "api/v1/payments/fetch-payment-modes",
        pmType: "MOBILE_MONEY",
      }),
    );
  }

  useEffect(() => {
    if (open) {
      fetchPaymentModesData();
    }
  }, [open]);

  useEffect(() => {
    if (
      payReceiverMobileNo?.length === 12 &&
      prevPhoneNumberRef.current !== payReceiverMobileNo &&
      !saving
    ) {
      prevPhoneNumberRef.current = payReceiverMobileNo;
      handleValidValidate();
    }
  }, [payReceiverMobileNo]);
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Direct Payment`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancelSingle}
        width={850}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid lg:grid-cols-2 lg:gap-x-5 grid-cols-1">
            <Form.Item
              name="pyWalId"
              className=""
              label={<span>Payment Source</span>}
              rules={[
                {
                  required: true,
                  message: "Please select payment source",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  subwalletData?.length > 0 &&
                  subwalletData?.map((item) => ({
                    value: item?.walId,
                    label:
                      item?.walName +
                      " - " +
                      item?.walCode +
                      " - " +
                      item?.walCurrency +
                      " " +
                      item?.walAvailableBalance,
                  }))
                }
                notFoundContent={
                  <div
                    onClick={() => navigate("/my-wallet")}
                    className="cursor-pointer text-ndovuRed"
                  >
                    Assign wallet to this user
                  </div>
                }
                onChange={(value) => {
                  const selectedItem = subwalletData?.find(
                    (item) => item?.walId === value,
                  );
                  setSelectedWallet(selectedItem || null);
                  setEnteredAmount(null);
                  setPaymentSourceName(selectedItem?.walName || "");
                  form.resetFields(["payPaymentAmount"]);
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase(),
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchSubWalletData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {dropLoading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              name="pyPmId"
              className=""
              label={<span>Mode of Payment</span>}
              rules={[
                {
                  required: false,
                  message: "Please select payment Mode",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  paymentModes?.length > 0 &&
                  paymentModes?.map((item) => ({
                    value: item?.pmId,
                    label: item?.pmName,
                  }))
                }
                onChange={(value) => {
                  const selectedItem = paymentModes?.find(
                    (item) => item?.pmId === value,
                  );
                  setPaymentModeName(selectedItem?.pmName || "");
                  if (
                    selectedItem?.pmName === "PAYBILL" ||
                    selectedItem?.pmName === "TILL_NUMBER"
                  ) {
                    fetchPaybillData(
                      selectedItem.pmName === "TILL_NUMBER"
                        ? "TILL NUMBER"
                        : selectedItem.pmName === "PAYBILL"
                          ? "PAYBILL"
                          : undefined,
                    );
                  }

                  form.setFieldsValue({
                    paybillOrTillNoId: "",
                    payPaybillAccountNo: "",
                    payReceiverMobileNo: "",
                  });
                  setPaybillName("");
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase(),
                  )
                }
              />
            </Form.Item>
            {paymentModeName === "PAYBILL" ? (
              <>
                <Form.Item
                  name="paybillOrTillNoId"
                  className=""
                  label={<span>Select Paybill</span>}
                  rules={[
                    {
                      required: false,
                      message: "Please select paybill",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      paybills?.length > 0 &&
                      paybills?.map((item) => ({
                        value: item?.pbId,
                        label:
                          item?.pbPaybill + " - " + formatText(item?.pbName),
                      }))
                    }
                    onChange={(value) => {
                      const selectedItem = paybills?.find(
                        (item) => item?.pbId === value,
                      );
                      setPaybillName(selectedItem?.pbName || "");
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase(),
                      )
                    }
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <div style={{ padding: 8 }}>
                          <Button
                            type="link"
                            onClick={() => setopenPaybill(true)}
                            style={{ padding: 0 }}
                          >
                            + Add new Paybill
                          </Button>
                        </div>
                      </>
                    )}
                  />
                </Form.Item>
                <Form.Item
                  name="payPaybillAccountNo"
                  label="Account Number"
                  rules={[
                    {
                      required: true,
                      message: "Enter Account Number",
                    },
                  ]}
                >
                  <Input className="input" />
                </Form.Item>
              </>
            ) : paymentModeName === "TILL_NUMBER" ? (
              <Form.Item
                name="paybillOrTillNoId"
                className=""
                label={<span>Select Till</span>}
                rules={[
                  {
                    required: false,
                    message: "Please select till",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    paybills?.length > 0 &&
                    paybills?.map((item) => ({
                      value: item?.pbId,
                      label: item?.pbPaybill + " - " + formatText(item?.pbName),
                    }))
                  }
                  onChange={(value) => {
                    const selectedItem = paybills?.find(
                      (item) => item?.pbId === value,
                    );
                    setPaybillName(selectedItem?.pbName || "");
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase(),
                    )
                  }
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <div style={{ padding: 8 }}>
                        <Button
                          type="link"
                          onClick={() => setopenPaybill(true)}
                          style={{ padding: 0 }}
                        >
                          + Add new Till
                        </Button>
                      </div>
                    </>
                  )}
                />
              </Form.Item>
            ) : paymentModeName === "MPESA" ? (
              <>
                <Form.Item
                  name="payReceiverMobileNo"
                  label="Receiver Number"
                  rules={[
                    {
                      required: true,
                      message:
                        "Please enter a valid phone number in the format +254XXXXXXXXX.",
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.length === 12) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "Phone number must be exactly 10 characters",
                          ),
                        );
                      },
                    },
                  ]}
                >
                  <PhoneInput
                    country="ke"
                    countryCodeEditable={false}
                    disabled={saving}
                    onKeyDown={(e) => {
                      const input = e.target;
                      const value = input.value?.replace(/[^0-9]/g, "");

                      if (e.key === "0" && (!value || value === "254")) {
                        e.preventDefault();
                        return;
                      }
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      if (
                        value &&
                        value.length >= 12 &&
                        !allowedKeys.includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className="input"
                  />
                </Form.Item>
                <Form.Item
                  name="payBeneficiaryDetails"
                  label="Receiver Name"
                  extra={
                    saving && isValidPhoneNumber ? <Spin size="small" /> : null
                  }
                  rules={[
                    {
                      required: true,
                      message: "Enter Receiver Name",
                    },
                  ]}
                >
                  <Input disabled={isAccountValidated} className="input" />
                </Form.Item>
              </>
            ) : null}

            <Form.Item
              name="pyPcId"
              className=""
              label={<span>Category</span>}
              rules={[
                {
                  required: false,
                  message: "Please select payment category",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  dataCat?.length > 0 &&
                  dataCat?.map((item) => ({
                    value: item?.pcId,
                    label: item?.pcName,
                  }))
                }
                onChange={(value) => {
                  fetchSubCategoryData(value);
                  const selectedItem = dataCat?.find(
                    (item) => item?.pcId === value,
                  );
                  setCategoryName(selectedItem?.pcName || "");
                  form.resetFields(["pyPscId"]);
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase(),
                  )
                }
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div style={{ padding: 8 }}>
                      <Button
                        type="link"
                        onClick={() => setopenCategory(true)}
                        style={{ padding: 0 }}
                      >
                        + Add new Category
                      </Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>

            {categoryName && (
              <Form.Item
                name="pyPscId"
                className=""
                label={<span>Sub Category</span>}
                rules={[
                  {
                    required: true,
                    message: "Please select payment sub-category",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataSubCat?.length > 0 &&
                    dataSubCat?.map((item) => ({
                      value: item?.pscId,
                      label: item?.pscName,
                    }))
                  }
                  onChange={(value) => {
                    const selectedItem = dataSubCat?.find(
                      (item) => item?.pscId === value,
                    );
                    setSubCategoryName(selectedItem?.pscName || "");
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase(),
                    )
                  }
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <div style={{ padding: 8 }}>
                        <Button
                          type="link"
                          onClick={() => setopenSubCategory(true)}
                          style={{ padding: 0 }}
                        >
                          + Add new Sub-Category
                        </Button>
                      </div>
                    </>
                  )}
                />
              </Form.Item>
            )}

            <Form.Item
              name="payValidate"
              valuePropName="checked"
              getValueFromEvent={(e) => (e.target.checked ? "YES" : null)}
            >
              <Checkbox>Validate</Checkbox>
            </Form.Item>

            {payValidate && (
              <>
                <Form.Item
                  name="payIdentifierType"
                  className=""
                  label={<span>Identifier Type</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please select identifier type",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      identifierTypeData?.length > 0 &&
                      identifierTypeData?.map((item) => ({
                        value: item?.value,
                        label: item?.label,
                      }))
                    }
                    onChange={() => {
                      form.resetFields(["payIdNumber"]);
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase(),
                      )
                    }
                  />
                </Form.Item>

                {payIdentifierType && (
                  <Form.Item
                    name="payIdNumber"
                    label={getIdentifierLabel()}
                    rules={[
                      {
                        required: true,
                        message: `Please enter ${getIdentifierLabel()}`,
                      },
                      {
                        validator(_, value) {
                          if (value) {
                            const strValue = value.toString();
                            if (strValue.length < 6) {
                              return Promise.reject(
                                `${getIdentifierLabel()} must be at least 6 digits`,
                              );
                            }
                            if (strValue.length > 12) {
                              return Promise.reject(
                                `${getIdentifierLabel()} must not exceed 12 digits`,
                              );
                            }
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      min={0}
                      maxLength={12}
                      parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                      className="input flex"
                    />
                  </Form.Item>
                )}
              </>
            )}
            <Form.Item
              extra={
                selectedWallet &&
                enteredAmount &&
                Number(selectedWallet?.walAvailableBalance) <
                  Number(enteredAmount) && (
                  <div className="text-[#2563EB] text-[.85rem] font-[400] leading-[1.5rem] gap-[.3rem]  flex items-center">
                    {selectedWallet?.walType === "DISBURSEMENT"
                      ? "Insufficient funds please do wallet transfer."
                      : selectedWallet?.walType === "COLLECTION"
                        ? "Insufficient funds please top up to proceed."
                        : null}
                    <span
                      className="text-[#1F54C8] text-[.85rem] font-[500] cursor-pointer"
                      onClick={() =>
                        selectedWallet?.walType === "DISBURSEMENT"
                          ? handleTransfer()
                          : selectedWallet?.walType === "COLLECTION"
                            ? handleViewWallet(selectedWallet)
                            : null
                      }
                    >
                      {selectedWallet?.walType === "DISBURSEMENT"
                        ? "+Transfer"
                        : selectedWallet?.walType === "COLLECTION"
                          ? "+Top Up Amount"
                          : null}
                    </span>
                  </div>
                )
              }
              name="payPaymentAmount"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Enter amount",
                },
              ]}
            >
              <InputNumber
                min={0}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                placeholder="Enter amount"
                className="input flex"
                onChange={(value) => setEnteredAmount(value)}
              />
            </Form.Item>
          </div>

          <Form.Item
            name="payPaymentReason"
            label="Reason for transfer"
            rules={[
              {
                required: true,
                message: "Enter reason for transfer",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Enter reason for transfer"
              className="input-textarea"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancelSingle}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className={`cstm-btn-2 ${
                    (Number(selectedWallet?.walAvailableBalance) <
                      Number(enteredAmount) ||
                      saving) &&
                    "!cursor-not-allowed"
                  }`}
                  disabled={
                    saving ||
                    Number(selectedWallet?.walAvailableBalance) <
                      Number(enteredAmount)
                  }
                >
                  {saving ? <Spin /> : "Next"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <VerificationModal
        handleFetchData={handleFetchData}
        open={openVerification}
        setopenVerification={setopenVerification}
        handleCancel={handleCancelVerification}
        handleCancelSingle={handleCancel}
      />

      <AddPaybillModal
        handleFetchData={fetchPaybillData}
        open={openPaybill}
        handleCancel={handleCancelPaybill}
        prodd=""
      />

      <CategoryAdd
        isModalOpen={openCategory}
        handleCancel={handleCancelCategory}
        handleFetch={fetchCategoryData}
        prodd=""
      />
      <SubCategoryAdd
        isModalOpen={openSubCategory}
        handleCancel={handleCancelSubCategory}
        handleFetch={() => fetchSubCategoryData(form.getFieldValue("pyPcId"))}
        prodd={
          form.getFieldValue("pyPcId")
            ? { pcId: form.getFieldValue("pyPcId") }
            : null
        }
      />

      <TransferModal
        handleFetchData={fetchFundsTransferData}
        open={openTransfer}
        setopenSingle={setOpenTransfer}
        handleCancel={handleCancelTransfer}
      />
    </>
  );
};
export default MpesaPaymentModal;
